class ResetPasswordController {
  constructor (UserService, $state, $stateParams, I18n) {
    'ngInject'
    this.I18n = I18n
    this.UserService = UserService
    this.$state = $state
    this.$stateParams = $stateParams
    this.isProcessing = false
    this.isReset = false
  }

  resetPassword (form) {
    if (form.resetPasswordForm.$valid) {
      this.isProcessing = true
      return this.UserService.resetPassword({email: this.email})
      .then((success) => {
        this.isReset = true
        this.isProcessing = false
        return Promise.resolve(success)
      }, (err) => {
        this.error = err
        if (this.error.data.meta.code === 524) {
          this.errorCode = this.error.data.meta.code
        }
        this.isProcessing = false
      })
    }
  }

}

export default ResetPasswordController



// WEBPACK FOOTER //
// ./src/app/pages/reset-password/reset-password.controller.js